import mainpageApi from './api/mainpageApi';

export const MAINPAGE_TRAD = 'mainpage/TRAD';
export const MAINPAGE_SIMP = 'mainpage/SIMP';
export const MAINPAGE_ENG = 'mainpage/ENG';

const initialState = {
	language: "tc",
}

export default (state = initialState, action) => {
	switch (action.type) {
		case MAINPAGE_TRAD:
			return {
				...state,
				language: "tc",
			};

		case MAINPAGE_SIMP:
			return {
				...state,
				language: "sc",
			};

		case MAINPAGE_ENG:
			return {
				...state,
				language: "en",
			};

		default:
			return state;
	}

}

export const mainpageUpdateTrad = () => {
	return dispatch => {
		dispatch({
			type: MAINPAGE_TRAD,
		});
	}
};

export const mainpageUpdateSimp = () => {
	return dispatch => {
		dispatch({
			type: MAINPAGE_SIMP,
		});
	}
};

export const mainpageUpdateEng = () => {
	return dispatch => {
		dispatch({
			type: MAINPAGE_ENG,
		});
	}
};

export const addRecord = () => {
	return dispatch => {
		return mainpageApi.addRecord().then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	}
}